import { motion } from "framer-motion";
import { SealCheck, Wrench } from "@phosphor-icons/react";
import { PRESTATIONS } from "../data/site";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import ServiceIcon from "../components/ServiceIcon";
import CtaBanner from "../components/CtaBanner";

const ACCENTS = ["#1A49F7", "#FC8529", "#FF3123", "#3CC0E7"];

export default function Prestations() {
  return (
    <div data-testid="prestations-page">
      <PageHero
        index="01"
        eyebrow="Prestations"
        title="Chaque énergie, son savoir-faire."
        intro="Installation, entretien et dépannage — nous couvrons l'ensemble de vos besoins en chauffage, énergies renouvelables, climatisation et plomberie."
      />

      <div className="mx-auto max-w-7xl px-6 pb-8 md:px-12">
        {PRESTATIONS.map((p, i) => (
          <section
            key={p.id}
            data-testid={`prestation-${p.id}`}
            className="grid grid-cols-1 items-center gap-10 border-t border-[#F0F0F0] py-16 lg:grid-cols-12 lg:gap-16 lg:py-24"
          >
            <div className={`relative lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl" style={{ backgroundColor: `${ACCENTS[i % ACCENTS.length]}14` }}>
                <ServiceIcon name={p.icon} weight="light" className="h-9 w-9" style={{ color: ACCENTS[i % ACCENTS.length] }} />
              </span>
              <p className="mt-6 text-xs font-semibold uppercase tracking-[0.25em]" style={{ color: ACCENTS[i % ACCENTS.length] }}>{p.subtitle}</p>
              <h2 className="mt-3 text-4xl font-bold tracking-tight text-[#14183A] md:text-5xl">{p.title}</h2>
              <p className="mt-6 max-w-lg text-lg font-light leading-relaxed text-[#5b6072]">{p.text}</p>
              {p.rge && (
                <span data-testid={`prestation-rge-${p.id}`} className="mt-7 inline-flex items-center gap-2 rounded-full border border-[#FC8529]/40 bg-[#FFF6EF] px-4 py-2 text-sm font-semibold text-[#B45309]">
                  <SealCheck weight="fill" className="h-4 w-4" />
                  Éligible RGE · MaPrimeRénov' · CEE
                </span>
              )}
            </div>
            <Reveal delay={0.1} className={`relative lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <span aria-hidden="true" className="absolute -z-10 rounded-full" style={{ width: 120, height: 120, border: `2px solid ${ACCENTS[i % ACCENTS.length]}`, opacity: 0.25, [i % 2 === 1 ? "left" : "right"]: -18, top: -18 }} />
              <motion.div
                whileHover={{ scale: 0.99 }}
                className="group aspect-[4/3] overflow-hidden rounded-[2rem] bg-[#F3F6FF]"
              >
                <img src={p.image} alt={p.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </motion.div>
            </Reveal>
          </section>
        ))}

        {/* Entretien & dépannage */}
        <section data-testid="prestation-entretien" className="border-t border-[#F0F0F0] py-16 lg:py-24">
          <div className="relative overflow-hidden rounded-[2rem] bg-[#14183A] px-8 py-14 text-white md:px-16 md:py-20">
            <span aria-hidden="true" className="decor-blob -right-16 -top-16" style={{ width: 300, height: 300, backgroundColor: "#1A49F7", opacity: 0.4 }} />
            <span aria-hidden="true" className="decor-blob -bottom-20 left-10" style={{ width: 260, height: 260, backgroundColor: "#FC8529", opacity: 0.25 }} />
            <div className="relative">
              <Wrench weight="light" className="h-14 w-14 text-[#3CC0E7]" />
              <h2 className="mt-6 max-w-2xl text-4xl font-bold tracking-tight md:text-5xl">Entretien & dépannage</h2>
              <p className="mt-6 max-w-2xl text-lg font-light leading-relaxed text-white/70">
                Au-delà de l'installation, nous assurons l'entretien régulier et le dépannage de l'ensemble de ces équipements — chaudières, pompes à chaleur, poêles, climatisations et installations sanitaires — pour préserver leur performance et votre confort dans la durée.
              </p>
            </div>
          </div>
        </section>
      </div>

      <CtaBanner />
    </div>
  );
}
